const b64 = (bytes) =>
  btoa(String.fromCharCode(...bytes)).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
const random = () => b64(crypto.getRandomValues(new Uint8Array(32)));
const challenge = async (v) =>
  b64(new Uint8Array(await crypto.subtle.digest("SHA-256", new TextEncoder().encode(v))));

export const ssoConfigured = () => !!process.env.REACT_APP_SSO_AUTHORIZE_URL;

export const redirectUri = () => `${window.location.origin}/auth/callback`;

export async function beginSocialPulseLogin(returnTo = "/") {
  const verifier = random();
  const state = random();
  const nonce = random();
  sessionStorage.setItem("mp-oidc", JSON.stringify({ verifier, state, nonce, returnTo }));
  const q = new URLSearchParams({
    response_type: "code",
    client_id: process.env.REACT_APP_SSO_CLIENT_ID,
    redirect_uri: redirectUri(),
    scope: "openid profile email",
    state,
    nonce,
    code_challenge: await challenge(verifier),
    code_challenge_method: "S256",
  });
  window.location.assign(`${process.env.REACT_APP_SSO_AUTHORIZE_URL}?${q}`);
}

export function readCallbackParams() {
  const q = new URLSearchParams(window.location.search);
  const saved = JSON.parse(sessionStorage.getItem("mp-oidc") || "null");
  const code = q.get("code");
  if (!saved || !code || q.get("state") !== saved.state) return null;
  sessionStorage.removeItem("mp-oidc");
  return { code, code_verifier: saved.verifier, nonce: saved.nonce, redirect_uri: redirectUri(), returnTo: saved.returnTo || "/" };
}
